module.exports = __webpack_public_path__ + "img/lazer.8da3b9b8.svg";